module.exports = __webpack_public_path__ + "img/typeGreen.0ec7ea48.png";